import React from 'react'
import { ToastContainer } from 'react-toastify'
import SubscriptionBar from '@/features/subscription/SubscriptionBar';
import { getTokenCount, selectNotification } from '@/api/rtk/userSelectors'
import { useSelector } from 'react-redux';
import Header from '@/shared/components/AppHeader'
import { useLocation } from 'react-router-dom';
import { useSubscription } from '@/shared/hooks/useSubscription'
import TrialEndModal from '@/features/subscription/TrialEndModal';
import Notification from '@/shared/components/Notification';
import { useTranslation } from 'react-i18next';
import { INTEGRATION_CLIENTS } from '@/shared/config/constants';

function Layout({ children }) {
  const { t } = useTranslation();
  const location = useLocation();
  const { trialEnded } = useSubscription();
  const userId = localStorage.getItem('user_id') || "";
  const invalidPaths = ['/reset-password', '/sign-up', '/verify-password'];
  const isIntegrationRoute = INTEGRATION_CLIENTS.some(client => 
    location.pathname.startsWith(`/integration/${client}`)
  );
  const showHeader = userId ? !invalidPaths.includes(location.pathname) && !isIntegrationRoute : false;
  const notification = useSelector(selectNotification);
  const tokenCount = useSelector(getTokenCount);

  const lowTokenWarning = tokenCount > 0 && tokenCount < 5000  ? t('tokens.lowWarning', { tokenCount }) : null;

  return (
    <div>
      {trialEnded && <TrialEndModal />}
      <SubscriptionBar noBorder={notification || lowTokenWarning}/>
      {!trialEnded && lowTokenWarning && <Notification text={lowTokenWarning} system={true}/>}
      {!trialEnded && notification && <Notification text={notification} system={true}/>}
      <div className={` ${trialEnded ? 'blur pointer-events-none' : ''}`}>
        <div id='reportInfoBody' className={`App w-full flex flex-col items-center justify-center font-SuisseIntl`}>
          <ToastContainer />
          {showHeader && <Header />}
          <>
            {children}
          </>
        </div>
      </div>
    </div>
  )
}

export default Layout
